import React from "react"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"
import type { MenuSubmenuRootChangeEventDetails } from "@base-ui/react/menu"

export type MenuSubmenuProps = {
  /** The submenu trigger and content */
  children?: React.ReactNode
  /** Whether the submenu is open (controlled) */
  open?: boolean
  /** Whether the submenu starts open (uncontrolled) */
  defaultOpen?: boolean
  /** Called when the submenu open state changes */
  onOpenChange?: (open: boolean, eventDetails: MenuSubmenuRootChangeEventDetails) => void
  /** When true, pressing Escape closes the entire menu hierarchy instead of only this submenu */
  closeParentOnEsc?: boolean
}

export function MenuSubmenu({ children, open, defaultOpen, onOpenChange, closeParentOnEsc }: MenuSubmenuProps) {
  return (
    <MenuPrimitive.SubmenuRoot
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      closeParentOnEsc={closeParentOnEsc}
    >
      {children}
    </MenuPrimitive.SubmenuRoot>
  )
}

MenuSubmenu.displayName = "Menu.Submenu"
